module.exports = __webpack_public_path__ + "double-grb-desktop.jpg";